export default __webpack_public_path__ + "static/media/26.1aadd2d6.gif";